import {Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MapsAPILoader} from '@agm/core';
import {Utilities} from '@shared/utilities/utilities.model';
import {MatDialogRef} from '@angular/material';
import { PositiveThemeService } from '@shared/service/positive-theme.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'amd-cc-dk-edit-address-dialog',
    templateUrl: './cc-dk-edit-address-dialog.component.html',
    styleUrls: ['./cc-dk-edit-address-dialog.component.scss']
})
export class CcDkEditAddressDialogComponent implements OnInit {
    address: string;
    searchControl: FormControl;
    autocomplete: google.maps.places.Autocomplete;
    place: google.maps.LatLng;
    placeStringInserted: string;
    autocompleteIsValid: boolean;
    isStreetNumberMissing = false;
    @ViewChild('searchAddress') searchAddress: ElementRef;
    isPositiveTheme: boolean;
	translateContext: TranslateContext = TranslateContext.CONTRACT_CLOSING;

    constructor(private mapsAPILoader: MapsAPILoader, private ngZone: NgZone, private positiveThemeService: PositiveThemeService, private dialogRef: MatDialogRef<CcDkEditAddressDialogComponent>) {
    }

    ngOnInit(): void {
        this.isPositiveTheme = this.positiveThemeService.getIsPositiveTheme();
        this.searchControl = new FormControl('', [Validators.required]);
        this.initGoogleAutocomplete();
    }

    initGoogleAutocomplete(): void {
        this.mapsAPILoader.load().then(() => {
            this.autocomplete = new google.maps.places.Autocomplete(
                this.searchAddress.nativeElement,
                {
                    types: ['address']
                }
            );
            this.autocomplete.setComponentRestrictions({country: 'it'});
            this.autocomplete.addListener('place_changed', () => {
                this.ngZone.run(() => {
                    if (
                        !Utilities.isVoid(this.autocomplete.getPlace()) &&
                        !Utilities.isVoid(
                            this.autocomplete.getPlace().geometry
                        ) &&
                        !Utilities.isVoid(
                            this.autocomplete.getPlace().geometry.location
                        )
                    ) {
                        this.place = this.autocomplete.getPlace().geometry.location;
                    } else {
                        this.place = null;
                    }
                    if (this.place === undefined || this.place === null) {
                        this.searchControl.setErrors({ErrorSearch: true});
                        this.autocompleteIsValid = false;
                        return;
                    } else {
                        this.isStreetNumberMissing = !this.autocomplete.getPlace().address_components.some(address_component => address_component.types.includes('street_number'));
                        this.placeStringInserted = this.searchAddress.nativeElement.value;
                        this.autocompleteIsValid = true;
                    }
                });
            });
        });
    }

    onAutocompleteKeyUp(): void {
        if (this.placeStringInserted && this.searchControl.value) {
            this.placeStringInserted.trim() === this.searchControl.value.trim() ? this.autocompleteIsValid = true : this.autocompleteIsValid = false;
        }
    }

    onCloseDialog(isConfirm: boolean): void {
        this.dialogRef.close({
            address: (isConfirm && this.autocompleteIsValid) ? this.autocomplete.getPlace() : null,
            place: (isConfirm && this.autocompleteIsValid) ? this.place : null
        });
    }
}

